/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { setFeiertageOverrideForMitarbeiter } from '../fn/feiertag-override/set-feiertage-override-for-mitarbeiter';
import { SetFeiertageOverrideForMitarbeiter$Params } from '../fn/feiertag-override/set-feiertage-override-for-mitarbeiter';

@Injectable({ providedIn: 'root' })
export class FeiertagOverrideApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `setFeiertageOverrideForMitarbeiter()` */
  static readonly SetFeiertageOverrideForMitarbeiterPath = '/v1/mitarbeiter/{mitarbeiterId}/feiertage-overrides';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setFeiertageOverrideForMitarbeiter()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  setFeiertageOverrideForMitarbeiter$Response(params: SetFeiertageOverrideForMitarbeiter$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return setFeiertageOverrideForMitarbeiter(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `setFeiertageOverrideForMitarbeiter$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  setFeiertageOverrideForMitarbeiter(params: SetFeiertageOverrideForMitarbeiter$Params, context?: HttpContext): Observable<void> {
    return this.setFeiertageOverrideForMitarbeiter$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
